import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { LakehouseLinkedService } from 'shell-models-lib';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';

@Metamodel.model({
    name: adfModelTypeMap.lakehouse.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(LakehouseLinkedService)
    }
})

export class LakehouseReadSettings extends BlobTypeStoreReadSettings {
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];
}
